'use client';

import { usePathname, useParams } from 'next/navigation';
import { getSeoUrl } from 'utils/links';

/**
 * Check if current path matches with current seoUrl + given path
 * @example
 * const isHomePage = usePathMatch('/');
 * const isCategoryPage = usePathMatch('/c/:category');
 * const isFilterCategoryPage = usePathMatch('/c/filter');
 */
export const usePathMatch = (path = '') => {
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es');
  // esite should always be a string without numbers or special characters, except for the dash (like demo-dealer).
  const params = useParams();
  const pathname = usePathname();
  const normalizedPath = getSeoUrl(params, path)
    .replace(/:(\w+)/g, (_, param) => params[param] as string)
    .replace(/\/$/, '');

  return pathname === normalizedPath;
};
